module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBoxVariants":{"notifications":{"success":"Produkty byly vloženy do košíku"},"quantity":{"label":"Celkem ks","button":"Do košíku"}}},"en":{}}')
  delete Component.options._Ctor
}
